module.exports = __webpack_public_path__ + "img/plane_down.d1739803.svg";